import config from '@/config/user.env.js';
import request from '@/utils/http';
import { Base64 } from 'js-base64';
/**
 * 文件在线预览接口
 * @param fileObj {Object}
 * @param fileObj.fileName {String} 附件文件名
 * @param fileObj.fileId {String} 附件ID
 * @param fileObj.fileUrl {String} 附件url
 * @return {undefined}
 *
 * **/
export function filePreview(fileObj, callback) {
    const fileArr = fileObj.fileUrl.split('.');
    const ext = (fileObj.fileType || fileArr[fileArr.length - 1]);
    let fileName = '';
    if (/\./.test(fileObj.fileName)) {
        fileName = fileObj.fileName;
    } else {
        fileName = fileObj.fileName + '.' + ext;
    }
    const url = config.filePreviewUrl + '/mip-doc-preview/viewer.html?sys=lsrm'
        + '&sign=' + new Date().getTime()
        + '&ext=' + ext
        + '&fd=' + fileObj.fileId
        + '&name=' + fileName
        + '&src=' + encodeURIComponent(fileObj.fileUrl);

    if (callback) {
        return callback(url);
    }

    window.open(url, '_blank ');
};

// 缓存字典请求结果，避免重复请求
let dictCache = null;

// 业务类型字典查询
export const getDictDataApi = (params) => {
    return request({
        url: 'api-mdm/dictionaryDetail/dict',
        method: 'get',
        params
    });
};

// 获取缓存的字典配置
const getDictConfig = async () => {
    if (dictCache !== null) {
        return dictCache;
    }
    try {
        const dictRes = await getDictDataApi({ dictCodes: 'LCRM_FILE_PREVIEW_SWITCH' });
        if (+dictRes.code === 0) {
            dictCache = dictRes.data;
        }
    } catch (e) {
        console.error('获取文件预览配置失败，使用默认新方法', e);
    }
    return dictCache;
};
/**
 * 文件在线预览接口
 * @param fileObj {Object}
 * @param fileObj.fileName {String} 附件文件名
 * @param fileObj.fileId {String} 附件ID
 * @param fileObj.fileUrl {String} 附件url
 * @param callback {Function} 可选回调，接收预览 URL；不传则直接 window.open
 * @return {undefined}
 */
export async function filePreviewV2(fileObj, callback) {
    // 查询字典判断使用新方法还是旧方法，默认使用新方法（使用缓存）
    let useNewMethod = true;
    const dictData = await getDictConfig();
    if (dictData) {
        const { LCRM_FILE_PREVIEW_SWITCH } = dictData;
        useNewMethod = LCRM_FILE_PREVIEW_SWITCH?.SWITCH === 'ON';
    }

    // 旧方法：使用 mip-doc-preview
    const oldMethod = () => {
        const fileArr = fileObj.fileUrl.split('.');
        const ext = (fileObj.fileType || fileArr[fileArr.length - 1]);
        let fileName = '';
        if (/\./.test(fileObj.fileName)) {
            fileName = fileObj.fileName;
        } else {
            fileName = fileObj.fileName + '.' + ext;
        }
        const url = config.filePreviewUrl + '/mip-doc-preview/viewer.html?sys=lsrm'
            + '&sign=' + new Date().getTime()
            + '&ext=' + ext
            + '&fd=' + fileObj.fileId
            + '&name=' + fileName
            + '&src=' + encodeURIComponent(fileObj.fileUrl);
        if (callback) {
            return callback(url);
        }
        window.open(url, '_blank ');
    };

    // 新方法：使用 kkFileView
    const newMethod = () => {
        const baseUrl = config.apiUrl ? config.apiUrl.replace(/\/$/, '') : '';
        const previewUrl = baseUrl + '/api-lcrm-file/onlinePreview?url=' + encodeURIComponent(Base64.encode(fileObj.fileUrl))
            + '&fileName=' + encodeURIComponent(Base64.encode(fileObj.fileName));
        if (callback) {
            return callback(previewUrl);
        }
        window.open(previewUrl);
    };

    useNewMethod ? newMethod() : oldMethod();
}
